import angular from 'angular';
import components from './components';

export default angular.module('insuranceSummaryOfCoverModal.scenes', [
  components,
]).name;
